import { ForgotPasswordMessages, TranslationForgotPasswordMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationForgotPasswordMessages = {
  [ForgotPasswordMessages.forgotPasswordRequiredEmail]: "Email é obrigatório",
  [ForgotPasswordMessages.forgotPasswordInvalidEmail]: "Email inválido",
  [ForgotPasswordMessages.forgotPasswordEmailLabel]: "Email",
  [ForgotPasswordMessages.forgotPasswordTitlePage]: "Esqueci minha senha",
  [ForgotPasswordMessages.forgotPasswordButton]: "Enviar email"
};
